"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookEvents = exports.EWebhookEvents = void 0;
var EWebhookEvents;
(function (EWebhookEvents) {
    EWebhookEvents["onStatusChange"] = "onStatusChange";
    EWebhookEvents["onIncomingMessage"] = "onIncomingMessage";
})(EWebhookEvents || (exports.EWebhookEvents = EWebhookEvents = {}));
/**
 * @deprecated Используйте EWebhookEvents
 */
var WebhookEvents;
(function (WebhookEvents) {
    WebhookEvents["onStatusChange"] = "onStatusChange";
    WebhookEvents["onIncomingMessage"] = "onIncomingMessage";
})(WebhookEvents || (exports.WebhookEvents = WebhookEvents = {}));
//# sourceMappingURL=webhook.enum.js.map